import { useEffect, useState } from "react";
import { buildApiUrl, createHeaders } from "../../services/apiClient";
import { getCurrentUserId } from "../../services/authService";

/**
 * Ranked "People you may know" suggestions, powered by the backend
 * /suggestions/people endpoint. Excludes self, existing follows in either
 * direction, and any pending connection request. Ranks by shared discussion
 * topics, mutual connections, and same-country / same-organization signals.
 */
export const useSuggestedProfiles = ({ limit = 10 } = {}) => {
  const [latestProfiles, setLatestProfiles] = useState([]);

  useEffect(() => {
    let isMounted = true;
    (async () => {
      try {
        const uid = getCurrentUserId();
        if (!uid) {
          if (isMounted) setLatestProfiles([]);
          return;
        }
        const params = new URLSearchParams();
        params.set("limit", String(limit));
        const res = await fetch(
          buildApiUrl(`/suggestions/people?${params.toString()}`),
          { headers: createHeaders({ userId: uid }) },
        );
        if (!res.ok) {
          throw new Error(`Failed to load suggestions (${res.status})`);
        }
        const data = await res.json();
        const items = Array.isArray(data?.items) ? data.items : [];
        if (isMounted) setLatestProfiles(items);
      } catch (e) {
        console.error("Failed to fetch people-you-may-know:", e);
        if (isMounted) setLatestProfiles([]);
      }
    })();
    return () => {
      isMounted = false;
    };
  }, [limit]);

  return latestProfiles;
};
